import styled from "styled-components";

import { media } from "components/common/media";
import bgImg from "images/thewire/bg.jpg";

export default styled.div`
  background: url(${bgImg});
  background-size: cover !important;
  height: 401px;
  position: relative;
  background-position-y: -93px;
  ${media.tablet`
    height: 300px;
  `};

  .layer {
    background: rgba(0, 0, 0, 0.36);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    max-height: 485px;
    ${media.tablet`
      max-height: 300px;
    `};
  }

  .callout {
    position: absolute;
    bottom: 27px;
    left: 75px;
    width: 100%;
    max-width: 950px;
    margin: 0 auto;
    transition: all 0.6s ease 0s;
    text-align: left;
    ${media.tablet`
      width: auto;
    `};
    h1 {
      font-size: 50px;
      color: #fff;
      font-weight: 400;
      margin-bottom: 15px;
      width: 100%;

      ${media.tablet`
        font-size: 24px;
        line-height: 115%;
      `};
    }
    h3 {
      font-weight: 400;
      letter-spacing: 0.48px;
      line-height: 28px;
      color: #fff;
      font-size: 16px;
      padding-top: unset;
      margin-bottom: unset;
      ${media.tablet`
        font-size: 14px;
        line-height: 125%;
      `};
    }
  }

  @media screen and (max-width: 767px) {
    background-position-y: unset;
    height: 170px;
    .callout {
      left: 15px;
      h1 {
        font-size: 21px;
      }
      h3 {
        font-size: 11px;
        width: 90%;
      }
    }
  }
`;
